import React, { FC, useEffect } from 'react';
import { LoadingBlock } from '../LoadingBlock';
import { fetchLogin } from '../../actions/AccountActions';

const Logout: FC = () => { 

    useEffect(() => {
        fetchLogin();
    }, []);

    return <LoadingBlock />;    
};

export default Logout;